import type { ComponentChildren, JSX } from "preact";

interface Props {
    children: ComponentChildren;
}

export function NavItem({ children }: Props): JSX.Element {
    return <li className="nav-item">{children}</li>;
}
